import React, { useState } from 'react';
import useStyles from './useStyles';
import { withScoutTheme } from '../../ThemeContext/ThemeContext';
import { useTheme, Button, Box } from '@mui/material';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ReactLoading from 'react-loading';
import Api from '../API';
import { ICalendlyEvent, ICalendlyScoutProps, IJobPosition } from '../types';
import { useCalendlyEvents } from '../hooks/useCalendlyEvents';
import { CalendlyDetails } from '../CalendlyDetails';

interface IProps {
  calendlyAccount: ICalendlyScoutProps;
  job: IJobPosition;
  applicationId: number;
  candidateName: string;
  apiKey: string;
}

function AddToCalendlyEventModal({ job, applicationId, candidateName, calendlyAccount }: IProps) {
  const [selectedEvent, setSelectedEvent] = useState<ICalendlyEvent | null>(null);
  const classes = useStyles();
  const theme = useTheme();
  const { isLoading, events } = useCalendlyEvents(calendlyAccount);

  const handleSubmit = async () => {
    await Api.addToEvent(job.id, {
      application_id: applicationId,
      event_type_url: selectedEvent?.scheduling_url
    });
    location.reload();
  };

  return (
    <>
      <div className={classes.root}>
        {!isLoading ? (
          <>
            <h4>
              Add to event {job.title} - {candidateName}
            </h4>
            <CalendlyDetails
              calendlyAccount={calendlyAccount}
              events={events}
              selectedEvent={selectedEvent}
              setSelectedEvent={setSelectedEvent}
            />
          </>
        ) : (
          <div className={classes.loading}>
            <ReactLoading type="spin" color={theme.palette.primary.main} width={45} height={45} />
          </div>
        )}
        <Box className={classes.buttonContainer}>
          <Button
            id="back-button"
            disableElevation
            variant="outlined"
            color="secondary"
            onClick={() => {
              window.history.back();
            }}
            startIcon={<ChevronLeftIcon />}
          ></Button>
          <Button
            id="next-button"
            disableElevation
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
            endIcon={<ChevronRightRoundedIcon />}
            disabled={!selectedEvent?.uri}
          >
            Book event
          </Button>
        </Box>
      </div>
    </>
  );
}

export default withScoutTheme(AddToCalendlyEventModal);
